import useChatsItems from '@src/hooks/useChatsItems';
import { increaseOffsetChatsRequest } from '@src/reducers/chats';
import { RefObject, useRef } from 'react';
import { useDispatch } from 'react-redux';
import useChatsItemsSize from '@src/hooks/useChatsItemsSize';
import ChatListItems from '../ChatListItems';
import './ChatRequests.css';

const ChatRequests: React.FC<{ chatsSearchRef: RefObject<HTMLDivElement> }> = ({
  chatsSearchRef,
}) => {
  const dispatch = useDispatch();
  const chatsRequestRef = useRef<HTMLDivElement>(null);

  const chatsItemsSize = useChatsItemsSize(chatsRequestRef, chatsSearchRef);
  const chatsRequestItems = useChatsItems();

  return (
    <div className="ChatRequestsBox" ref={chatsRequestRef}>
      <ChatListItems
        key="CHATS_REQUEST"
        items={chatsRequestItems}
        height={chatsItemsSize}
        onScrollBottom={() => dispatch(increaseOffsetChatsRequest())}
      />
    </div>
  );
};

export default ChatRequests;
